import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Right Type List with Query (for remote operations)
export const getWaterRightTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHT_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Right Type List with Query
export const getWaterRightTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHT_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Right Type
export const getWaterRightType = water_right_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHT_TYPE}${water_right_type_id}`
	);
};

// Add New Water Right Type
export const addNewWaterRightTypeApi = water_right_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_RIGHT_TYPE}`,
		water_right_type
	);
};

// Update Water Right Type
export const updateWaterRightTypeApi = water_right_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_RIGHT_TYPE}${water_right_type._id}`,
		water_right_type
	);
};

// Delete Water Right Type
export const deleteWaterRightTypeApi = water_right_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_RIGHT_TYPE}${water_right_type_id}`
	);
};

// Check if Water Right Type Exists
export const checkWaterRightTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_RIGHT_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
